import React, { useState, useEffect } from "react";

import * as api from '../api/index'

import {
  Typography,
  Button,
  IconButton,
  ButtonGroup,
  Modal,
  TextField,
  Divider,
} from "@material-ui/core";
import { useDiscount } from "../Context/DiscountContext";
import { useCart } from "../Context/CartContext";
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import useStyles from "./CartStyles";

const CartSummary = ({ currency }) => {
    const classes=useStyles();
    const {
        discountType,
        setDiscountType,
        discountVal,
        setDiscountVal,
        discountFlag,
        setDiscountFlag,
        openDiscountbox,
        setOpenDiscountbox,
        handleDiscountTypeChange,
        handleDisountBoxOpen,
        handleDisountBoxClose,
        handleAddDiscount,
        calculateDiscount,
        clearDiscount,
      } = useDiscount();
      const {
        cartItems,
        selectedIndex,
        addToCart,
        removeFromCart,
        incrementQuantity,
        decrementQuantity,
        getTotalPrice,
        getSubTotalPrice,
        calculatePrice,
        handleOpenQtyDialog,
        handleCloseQtyDialog,
        QtydialogOpen,
        handleQuantityChange,
        calculateVat,
        subTotal,
        setSubTotal,
        setCartItems,
        vat,
        setVat,
        getOriginalSubTotalPrice,
      } = useCart();

      const isError =
      (discountType && discountVal > 100) || discountVal >= getSubTotalPrice();

// State for permissions and loading
const [canApplyDiscount, setCanApplyDiscount] = useState(false);
const [isAdmin, setIsAdmin] = useState(false);
const [loading, setLoading] = useState(true);

// Fetch permissions from database
useEffect(() => {
  const fetchPermissions = async () => {
    try {
      const profile = JSON.parse(localStorage.getItem("profile")) || {};
      if (!profile.token) throw new Error("No token found");
      setIsAdmin(profile?.result?.userType?.includes("admin") || false);

      const { data } = await api.getUserPermissions();
      setCanApplyDiscount(data.canApplyCustomDiscount || false);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching permissions:", error.message);
      setCanApplyDiscount(false); // Fallback to no permission
      setLoading(false);
    }
  };
  fetchPermissions();
}, []);

  return (
    <div className={classes.totalAmountSection}>
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Original Sub-Total:{" "}
        <span className={classes.amountValue}>
          {`${currency}${getOriginalSubTotalPrice().toFixed(2)}`}
        </span>
      </Typography>
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Adjusted Sub-Total:{" "}
        <span className={classes.amountValue}>
          {`${currency}${getSubTotalPrice().toFixed(2)}`}
        </span>
      </Typography>
      {Math.abs(getSubTotalPrice() - getOriginalSubTotalPrice()) > 0.009 && (
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.totalAmountText}
        >
          Adjustment Difference:{" "}
          <span className={classes.amountValue}>
            {`${currency}${(getSubTotalPrice() - getOriginalSubTotalPrice()).toFixed(2)}`}
          </span>
        </Typography>
      )}
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Discount:{" "}
        <span className={classes.amountValue}>
          {discountVal && discountFlag && cartItems.length ? (
            <>
              <span>
                <Button
                  variant="contained"
                  color="lightGrey"
                  className={classes.button}
                  endIcon={<ClearIcon />}
                  onClick={clearDiscount}
                >
                  {currency}
                  {discountVal.toFixed(2)}
                </Button>
              </span>
            </>
          ) : (
            <>
            <IconButton
                disabled={loading || !cartItems.length || (!isAdmin && !canApplyDiscount)}
                aria-label="add"
                onClick={handleDisountBoxOpen}
                style={{
                  cursor: (loading || !cartItems.length || (!isAdmin && !canApplyDiscount)) ? 'not-allowed' : 'pointer'
                }}
              >
                <AddIcon fontSize="medium" />
              </IconButton>
              
            </>
          )}
        </span>
      </Typography>

      <Modal
        open={openDiscountbox}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleDisountBoxClose();
          }
        }}
      >
        <div className={classes.modal}>
          <TextField
            error={isError}
            helperText={isError ? "Incorrect entry." : null}
            type="number"
            label="Discount"
            value={discountVal}
            onChange={(e) => {
              setDiscountVal(e.target.value);
            }}
            // Add your input field props here
          />
          <ButtonGroup
            disableElevation
            variant="contained"
            aria-label="Disabled elevation buttons"
            style={{ marginLeft: 10 }}
          >
            <Button
              onClick={handleDiscountTypeChange}
              color={discountType === false ? "primary" : "default"}
            >
              Flat
            </Button>
            <Button
              onClick={handleDiscountTypeChange}
              color={discountType ? "primary" : "default"}
            >
              %
            </Button>
          </ButtonGroup>
          <div className={classes.modalButtons}>
            <Button
              variant="contained"
              color="primary"
              disabled={isError}
              onClick={() => {
                handleAddDiscount(getSubTotalPrice().toFixed(2));
              }}
              className={classes.AddButtonModal}
            >
              Add
            </Button>
            <IconButton
              aria-label="clear"
              onClick={handleDisountBoxClose}
              style={{ marginTop: "auto" }}
            >
              <ClearIcon />
            </IconButton>
          </div>
        </div>
      </Modal>
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Vat:{" "}
        <span className={classes.amountValue}>
          {`${currency}${calculateVat().toFixed(2)}`}
        </span>
      </Typography>
      <Divider />
      <Typography
        variant="h5"
        color="initial"
        className={classes.totalAmountText}
        style={{ marginTop: "10px" }}
      >
        Total Amount:{" "}
        <span className={classes.amountValue}>
          {`${currency}${getTotalPrice().toFixed(2) || 0.0}`}
        </span>
      </Typography>
    </div>
  );
};

export default CartSummary;
